
import React, { VoidFunctionComponent } from 'react';
import { DisplayStars } from '@/components/responsive/product/seller/DisplayStars';
import { ProductReviewListStatistics } from "@/models/scope/productSheet/reviews/ProductReviewListStatistics";
import { LAYER_TYPE, MAX_RATING } from "@/utils/constants";
import Utils from "@/libs/Utils";
import {dispatchProductSheetQuestionsResponsesHandleClick} from "@/animations/responsive/productPageTracking";

interface Props {
    reviewListStatistics: ProductReviewListStatistics;
    underline?: boolean;
    setLayerType: (layerType: string) => void;
}

export const Rating: VoidFunctionComponent<Props> = ({ reviewListStatistics, underline, setLayerType }) => {
    const { rateAverage, total } = reviewListStatistics;
    const isRated = parseInt(total) > 1;

    return (
        <div
            className={`rating-block ${isRated && 'clickable'} `}
            onClick={() => {
                if (isRated) {
                    setLayerType(LAYER_TYPE.RATING);
                    dispatchProductSheetQuestionsResponsesHandleClick( "avis client")
                }
            }}
        >
            {isRated ? (
                <>
                    <div className='rating-stars'>
                        <DisplayStars score={rateAverage} />
                    </div>
                    <p
                        className={`rating-text ${underline ? 'underline' : ''}`}
                    >{`${Utils.getDecimalFormat(
                        rateAverage,
                    )}/${MAX_RATING.toString()} - ${total} avis`}</p>
                </>
            ) : (
                <div className='rating-block'>
                    <img src={"/assets/images/responsive/icons/star-empty.svg"} alt='empty star' />
                    <p className='rating-text'> Aucun avis pour le moment</p>
                </div>
            )}
        </div>
    )
}